import { TranslateModule } from '../../../shared/translate/translate.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MatTableModule, MatPaginatorModule, MatButtonModule, MatMenuModule, MatSortModule } from '@angular/material';
import { CdkTableModule } from '@angular/cdk/table';
import { OrganizationTableComponent } from './organization-table.component';

@NgModule({
  declarations: [OrganizationTableComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatTableModule,
    CdkTableModule,
    MatPaginatorModule,
    MatButtonModule,
    MatMenuModule,
    MatSortModule,
    TranslateModule
  ],
  exports: [
    OrganizationTableComponent
  ]
})
export class OrganizationTableModule { }
